<template>
  <div class="buttons">
    <!-- <router-link
      class="button is-light"
      active-class="is-primary"
      :to="{ name: 'user' }"
      exact
    >
      <span class="icon is-small">
        <i class="mdi mdi-briefcase-account-outline"></i>
      </span>
      <span>Кабинет</span>
    </router-link> -->
    <router-link class="button is-light" active-class="is-primary" :to="{ name: 'templates' }">
      <span class="icon is-small">
        <i class="mdi mdi-paperclip"></i>
      </span>
      <span>Шаблоны</span>
    </router-link>

    <router-link class="button is-light" active-class="is-primary" :to="{ name: 'documents' }">
      <span class="icon is-small">
        <i class="mdi mdi-file-document-outline"></i>
      </span>
      <span>Документы</span>
    </router-link>

    <router-link class="button is-light" active-class="is-primary" :to="{ name: 'charts' }">
      <span class="icon is-small">
        <i class="mdi mdi-chart-bar-stacked"></i>
      </span>
      <span>Чарты</span>
    </router-link>

    <router-link class="button is-light" active-class="is-primary" :to="{ name: 'favouritesList' }">
      <span class="icon is-small">
        <i class="mdi mdi-star-outline"></i>
      </span>
      <span>Избранное</span>
    </router-link>

    <!-- <router-link
      class="button is-light"
      active-class="is-primary"
      :to="{ name: 'profile' }"
    >
      <span class="icon is-small">
        <i class="mdi mdi-account-outline"></i>
      </span>
      <span>Профиль</span>
    </router-link> -->
  </div>
</template>

<script>
export default {
  name: 'UserMenu'
};
</script>
